import { InvalidOperationException, NullReferenceException } from '../../../Exceptions';
import { isUndefinedOrNull } from '../../../TypeHelpers';
export default function single(enumerable, predicate) {
    if (!isUndefinedOrNull(predicate)) {
        enumerable = enumerable.where(predicate);
    }
    const en = enumerable.take(2).getEnumerator();
    let returnValue;
    while (en.moveNext()) {
        if (!isUndefinedOrNull(returnValue)) {
            throw new InvalidOperationException("More than one match in the collection!");
        }
        returnValue = en.current;
    }
    if (isUndefinedOrNull(returnValue)) {
        throw new NullReferenceException("The result is undefined!");
    }
    return returnValue;
}
